import React from "react";

import { TableRow, TableCell, makeStyles } from "../helper";

const useStyles = () => ({
  rowStyle: () => ({ backgroundColor: "rgba(250, 250, 250, 1)" }),
  tableRow: () => ({ "&:last-child td, &:last-child th": { border: 0 } }),
});

const useClasses = makeStyles(() => ({
  label: { fontWeight: 700 },
  subLabel: { fontWeight: 500, fontSize: 12 },
}));

export default function ChallanHeaderRow({ columnConfig }) {
  const styles = useStyles();
  const classes = useClasses();

  return (
    <TableRow sx={styles.rowStyle}>
      {columnConfig.map((conf, idx) => {
        return (
          <TableCell key={idx + conf.key} align={conf.align}>
            <span className={classes.label}>{conf.label}</span>
            <span className={classes.subLabel}>
              <br />
              {conf.subLabel}
            </span>
          </TableCell>
        );
      })}
    </TableRow>
  );
}
